import { formatUtcDateTime } from './dateTime'

const TransformDateTime = datetime => formatUtcDateTime(datetime)

export default TransformDateTime